import React from "react";
import { FormField } from "../Field/FormField";
import { SelectField as Select } from "../Field/SelectField";
import { FieldProps } from "./TextField";

export const SelectField = ({ name, field }: FieldProps) => {
    return (
        <FormField label={field.label} name={name}>
            <Select>
                <option />

                {field.options?.map((option) => (
                    <option key={option} value={option}>
                        {option}
                    </option>
                ))}
            </Select>
        </FormField>
    );
};
